import React from "react";
import useAtolInfoController from "./useAtolInfo.controller.js";
import { ATOLLogo } from "../../../../../ATOL/ATOLLogo.js";
import { Stack, Text } from "@bookingcom/bui-react";
import useProfiler from "../../../../../../../hooks/useProfiler.js";
import { track } from "@flights/et-universal";
const useAtolInfo = (flight) => {
    const { header, atolText } = useAtolInfoController(flight);
    const { isMobile, isDesktop } = useProfiler();
    if (!atolText)
        return undefined;
    return {
        header,
        content: (isDesktop() && !!track("flights_funnel_new_fd_page_desktop")) ||
            (isMobile() && !!track("flights_funnel_new_fd_page_mobile")) ? undefined : (React.createElement(Stack, { direction: "row", gap: 4 },
            React.createElement(ATOLLogo, null),
            React.createElement(Stack.Item, { grow: true },
                React.createElement(Text, { variant: "body_2" }, atolText))))
    };
};
export default useAtolInfo;
